<script>
    import { createEventDispatcher } from 'svelte'
    export let label = null
    export let icon = null
    export let color = '#7ED321'
    export let alt = null
    export let style = ''
    export let closeable = false
    import { Close } from '../Icons/custom'
    import { getCSSVar } from '../../utils.js'
    $: color =
        color.match(/^rgb.+|^#[a-f|A-F|0-9]+|\w+/) && color.slice(0, 2) !== '--'
            ? color
            : getCSSVar(color)
    import { Typography } from './'
    const dispatch = createEventDispatcher()
    function onClose() {
        dispatch('close')
    }
</script>

<!--  -->
<span
    title={alt}
    style={`background: ${color}; ${alt ? 'cursor: help' : ''}; ${style}`}
>
    {#if label}
        <Typography type="caption" color="white">{label}</Typography>
    {:else}
        <Typography type="caption" color="white"><slot /></Typography>
    {/if}
    {#if icon}
        <svelte:component this={icon} size={16} color="white" />
    {/if}
    {#if closeable}
        <p class="close" on:click={onClose}>
            <Close size={15} />
        </p>
    {/if}
</span>

<style>
    span {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 4px 9px;
        position: relative;
        color: black;
        width: fit-content;
        /* block-size: fit-content; */
        gap: 5px;
        border-radius: 100px;
        /* min-width: 84px; */
        white-space: nowrap;
        /* width: auto; */
        height: 24px;
        user-select: none;
    }
    .close {
        display: flex;
        cursor: pointer;
        margin: 0;
        padding: 0;
        border-radius: 50%;
    }
    .close:hover {
        background-color: rgba(255, 255, 255, 0.15);
    }
    /* span::before {
    content:'';
    display: block;
    flex-direction: row;
    background-color: aqua;
    z-index: 0;
    justify-content: flex-start;
    align-items: center;
    padding: 4px 9px;
    position: relative;
    border-radius: 100px;
    min-width: 84px;
    width: auto;
    height: 24px;
    user-select: none;
  } */
</style>
